import { render } from "./ProductCarouselV2.vue?vue&type=template&id=f93807dc&scoped=true"
import script from "./ProductCarouselV2.vue?vue&type=script&lang=js"
export * from "./ProductCarouselV2.vue?vue&type=script&lang=js"

import "./ProductCarouselV2.vue?vue&type=style&index=0&id=f93807dc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93807dc"]])

export default __exports__